import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";
import { Home } from "@App/Pages/Partner/Holman/Home";
import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";
import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";

export function Holman() {
  const { config } = useOrganizationConfig();

  return (
    <DefaultRoutes
      layout={
        <DefaultPartnerLayout
          logos={config.navbar.logos}
          backToPartnerButton={config.navbar.backToPartnerButton}
        />
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
